import classNames from 'classnames/bind';
import styles from './ActivityPanel.module.css';
import { BarGraphData } from '../../../types/dashboard';
import PanelContainer from './PanelContainer';
import PanelHeader from './PanelHeader';
import { PEAK_LEARNING_HOURS } from '../../../constants';
import { isMobile } from '../../../utils/util';

interface VerticalBarPanelProps {
  cardId: string;
  title: string;
  data: BarGraphData[];
  topItemName?: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function VerticalBarPanel({
  cardId,
  title,
  data,
  topItemName,
  isOpen,
  onClose,
}: VerticalBarPanelProps) {
  const cx = classNames.bind(styles);

  const highestValue = Math.max(...data.map((item) => item.value));
  const dataWithPercentage = data.map((item) => ({
    ...item,
    percentage: highestValue > 0 ? (item.value / highestValue) * 100 : 0,
  }));
  const isTimeRange = cardId.includes('time-range');

  return (
    <PanelContainer isOpen={isOpen}>
      <PanelHeader cardId={cardId} title={title} onClose={onClose} />
      <div className={cx('widget_content', 'graph_bar_v', cardId)}>
        {isMobile || (
          <ul className={cx('graph_list')}>
            {dataWithPercentage.map((item) => (
              <li
                key={item.name}
                className={cx('graph_item', {
                  highest: item.value === highestValue,
                })}
              >
                <div
                  className={cx('bar_graph')}
                  style={
                    {
                      '--target-height': `${item.percentage}%`,
                    } as React.CSSProperties
                  }
                />
                <span className={cx('name')}>
                  {item.name}
                  {isTimeRange ? '시' : ''}
                </span>
              </li>
            ))}
          </ul>
        )}
        {topItemName && (
          <div className={cx('info')}>
            <p>
              {isTimeRange ? '' : '일주일 중 '}
              <span className={cx('strong_text')}>{topItemName}</span>에
            </p>
            <p>{PEAK_LEARNING_HOURS}</p>
          </div>
        )}
      </div>
    </PanelContainer>
  );
}
